export const MAX_META_DESCRIPTION_LENGTH = 160

export function truncateDescription(text: string, maxLength = MAX_META_DESCRIPTION_LENGTH): string {
  if (text.length <= maxLength) return text

  const limit = maxLength - 1 // reserve 1 character for the ellipsis
  let cut = text.slice(0, limit)
  const lastSpace = cut.lastIndexOf(' ')
  if (lastSpace > 0) cut = cut.slice(0, lastSpace)
  cut = cut.replace(/[\s,;:.!?]+$/, '')

  return `${cut}…`
}
